import { useGetUser } from './useGetUser';

export const useGetCurrentBoardId = () => {
  const { data } = useGetUser();

  return data?.lastBoard.id;
};
